<template>
  <div class="condition">
    <h3 class="condition__header" @click="showBlock = !showBlock">
        Условия предоставления микрокредитов с графиком погашения в MicroFin
        <img src="https://files.prodengi.kz/assets/408653211-1739697844.svg" alt="Стрелка" class="condition__arrow" :class="{'condition__arrow_toggle': showBlock}">
    </h3>
    <div v-show="showBlock">
    <div class="condition__block"><h3 class="condition__title" >
        Срок микрокредита и ставка вознаграждения
        </h3> <p class="condition__text" >
          Минимальный срок – 1 месяц, максимальный срок – 12 месяцев
        </p><p class="condition__text" >
          Минимальная ставка - 37,5% , максимальная ставка - 37,6%
        </p><p class="condition__text" >
          Комиссия за досрочное погашение отсутствует
        </p></div><div class="condition__block" ><h3 class="condition__title" >
          Ответственность за неисполнение условий договора
        </h3> <p class="condition__text" >
          В случае неисполнения своих обязательств по договору микрокредита, при нарушении срока возврата микрокредита, на сумму просроченного платежа будет начисляться штраф в размере 0,5% в день, но не более 10% от суммы выданного микрокредита. Продолжительность начисления 90 календарных дней. Других комиссий по договору микрокредита не предусмотрено.
        </p></div><div class="condition__block" ><h3 class="condition__title" >
          Методы взыскания задолженности
        </h3> <p class="condition__text" >
          В случае просрочки исполнения обязательств Компания вправе применять все предусмотренные законодательством меры по взысканию задолженности, включая привлечение коллекторских агентств и обращение в суд.
        </p></div><div class="condition__block" ><h3 class="condition__title" >
          Возможное влияние на рейтинг кредитоспособности клиента
        </h3> <p class="condition__text" >
          В случае просрочки Компания будет передавать данные о сумме и сроке просрочки в кредитные бюро, что может повлиять на кредитную историю и кредитный рейтинг заемщика.
        </p></div><div class="condition__block" ><h3 class="condition__title" >
          Условия получения микрокредита
        </h3> <p class="condition__text" >
          Микрокредит выдается только по запросу клиента и без комиссий.
        </p></div><div class="condition__block" ><h3 class="condition__title" >
          Пример расчета общей стоимости микрокредита
        </h3> <p class="condition__text" >
          Сумма: 300 000 тг
        </p><p class="condition__text" >
          Срок – 6 мес.
        </p><p class="condition__text" >
          Годовая ставка - 37,5%
        </p><p class="condition__text" >
          ГЭСВ - 44,67%
        </p><p class="condition__text" >
          Ежемесячный платеж - 55 609 тг.
        </p><p class="condition__text" >
          Переплата - 33 654 тг.
        </p><p class="condition__text" >
          Дата начала - 20.09.2026
        </p><p class="condition__text" >
          Дата завершения - 20.02.2027
        </p><p class="condition__text" >
          Адрес компании: г. Алматы, мкр. Рахат, ул. Култобе, д.4
        </p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Conditions',
  data: () => ({
    showBlock: false
  })
}
</script>

<style lang="scss">
.condition {
  margin-top: 30px;
  text-align: left;
  background: #f6f5fa;

  &__header {
    display: flex;
    align-items: center;
    padding: 16px 0;
    margin: 0 20px;

    cursor: pointer;
    font-size: 12px;
    line-height: 16px;
  }

  &__arrow {
    margin-left: 8px;
  }

  &__arrow_toggle {
    transform: rotate(180deg);
  }

  &__content {
    padding-bottom: 20px;
  }

  &__title {
    margin: 5px 20px;

    font-size: 12px;
    line-height: 16px;
  }

  &__text {
    padding-bottom: 8px;
    margin: 0 20px;

    color: #000000;
    font-style: normal;
    font-weight: 400;
    font-size: 9px;
    font-family: Open Sans, Arial;
  }
}
</style>
